import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function BadgeIcon(props: IconProps) {
    return <Icon {...props} iconKey={"badge"}/>
}
